// Dialog Box for creating / updating Note -  Pop-up
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Grid,
  MenuItem,
  Menu,
  ListItemText,
  Button,
  TextField,
  InputAdornment,
} from '@mui/material';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import Tooltip from '@mui/material/Tooltip';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CheckIcon from '@mui/icons-material/CheckBoxRounded';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import SearchIcon from '@mui/icons-material/Search';
import { getDPList } from '../../actions/Users/authenticateInventory';
import close from '../../asset/image/cross.svg';
import '../InventoryWarehouseTable/inventoryWarehouse.css';
import _ from 'lodash';
import {
  getOu,
  getOuforReports,
  getUserOu,
  populateForParent,
  getParentDp,
} from '../../utils/util';
var Loader = require('react-loader');

interface OuItem {
  id: string;
  name: string;
  _childern: OuItem[];
}

interface PopupState {
  // Define the structure of popupState if needed
}

const Org_Drop_Down = (props) => {
  const {
    authReducer,
    getDPList,
    isSmall = false,
    setOu,
    className,
    deviceOu,
    isReports,
    is_report_edit,
    disableUserOuEdit = false,
    disabledOuIds = [],
    alreadySharedCount = 0,
  } = props;
  const [parent_ou, setParentOu] = useState(
    _.isEmpty(deviceOu) ? authReducer.selectedOu : deviceOu,
  );
  const [organisations, setOrganisations] = useState<any[]>([]);
  const [selectedOu, setSelectedOu] = useState<any[]>(
    is_report_edit?.org_names
      ? [...is_report_edit.org_names]
      : [parent_ou.name],
  );
  const [selectedOrgList, setSelectedOrgList] = useState<any[]>(
    is_report_edit?.orgs_id ? [...is_report_edit.orgs_id] : [parent_ou.id],
  );
  const [loading, setLoading] = useState<Boolean>(false);
  const [showOuList, setShowOuList] = useState(true);
  const [ouSearchValue, setOuSearchValue] = useState('');

  const [newOrganisationsList, setNewOrganisationsList] = useState<any>([]);
  const [selectedOuDisplayName, setSelectedOuDisplayName] = useState(() => {
    const totalExtra = alreadySharedCount;
    return totalExtra > 0 ? `${parent_ou.name} +${totalExtra}` : parent_ou.name;
  });

  useEffect(() => {
    if (
      is_report_edit &&
      is_report_edit !== undefined &&
      Object.keys(is_report_edit).length
    ) {
      updateDisplayName(is_report_edit.org_names);
    }
  }, [is_report_edit?.org_names]);

  useEffect(() => {
    updateDisplayName(selectedOu);
  }, [alreadySharedCount]);

  useEffect(() => {
    setOu(selectedOrgList);
  }, [selectedOrgList]);

  useEffect(() => {
    if (authReducer.selectedOu && authReducer.selectedOu?.name) {
      setOrganisations([authReducer?.selectedOu]);
    }
    getDPList();
  }, []);

  const handleOuClose = (popupState: any = null) => {
    if (popupState) {
      popupState.close();
    }
  };

  const handleOuSearch = async (value) => {
    setOuSearchValue(value);
    setLoading(true);
    //getDPList(value);
  };

  // useEffect(() => {
  //   if (authReducer.getDPList && authReducer.getDPList.dps) {
  //     let _organisations: any[] = [];
  //     if (authReducer.getDPList.dps && authReducer.getDPList.dps.length > 0) {
  //       _organisations = getParentDp(authReducer.getDPList.dps, parent_ou.name);
  //       if (loading) {
  //         setLoading(false);
  //       }
  //       setOrganisations(_organisations);
  //       authReducer.getDPList = {};
  //     }
  //   }
  // }, [authReducer.getDPList]);
  const searchOuList = (data, searchValue) => {
    const recursiveSearch = (arr) => {
      let result: any = [];
      for (let item of arr) {
        let children: any = [];
        if (item.parent_of && item.parent_of.length > 0) {
          children = recursiveSearch(item.parent_of);
        }
        if (
          item.name.toLowerCase().includes(searchValue.toLowerCase()) ||
          children.length > 0
        ) {
          result.push({
            name: item.name,
            id: item.id,
            _childern: children,
          });
        }
      }
      return result;
    };
    const ouList = {
      name: data.name,
      id: data.id,
      _childern: recursiveSearch(data.parent_of),
    };

    return ouList;
  };
  useEffect(() => {
    if (loading) {
      setLoading(false);
    }
    if (
      !_.isEmpty(authReducer.getDPList) &&
      authReducer.getDPList.dps &&
      authReducer.getDPList.dps.length > 0 &&
      ouSearchValue
    ) {
      const ouList = authReducer.getDPList.dps[0];
      const result = searchOuList(ouList, ouSearchValue);
      setNewOrganisationsList([result]);
    } else if (authReducer.getDPList && authReducer.getDPList.dps) {
      let _organisations: any[] = [];
      if (authReducer.getDPList.dps && authReducer.getDPList.dps.length > 0) {
        authReducer.getDPList.dps.map((item) => {
          _organisations = populateForParent(item, null, _organisations);
        });
      }
      setOrganisations(_organisations);

      // authReducer.getDPList = {};
    }
  }, [authReducer.getDPList, ouSearchValue]);

  const handleOuClick = (event, org, popupState) => {
    let name: string = org.name;
    // Prevent toggling the user's own OU when disableUserOuEdit is true
    if (disableUserOuEdit && org.id === parent_ou.id) {
      return;
    }

    let isChecked = !selectedOu.includes(name);
    let _selectedOu = [...selectedOu];
    let _selectedOrgList = [...selectedOrgList];
    if (
      _selectedOu?.length &&
      (!is_report_edit ||
        is_report_edit == undefined ||
        Object.keys(is_report_edit).length === 0)
    )
      _selectedOu = _selectedOu.filter((item) => item !== parent_ou.name);

    if (
      _selectedOrgList?.length &&
      (!is_report_edit ||
        is_report_edit == undefined ||
        Object.keys(is_report_edit).length === 0)
    )
      _selectedOrgList = _selectedOrgList.filter(
        (item) => item !== parent_ou.id,
      );

    if (isChecked) {
      _selectedOu = [..._selectedOu, name];
      _selectedOrgList = [..._selectedOrgList, org.id];
    } else {
      _selectedOu = _selectedOu.filter((item) => item !== name);
      _selectedOrgList = _selectedOrgList.filter((item) => item !== org.id);
    }

    setSelectedOu(_selectedOu);
    setSelectedOrgList(_selectedOrgList);
    updateDisplayName(_selectedOu);
  };

  const updateDisplayName = (ou_name_list) => {
    const totalExtra = ou_name_list.length - 1 + alreadySharedCount;
    if (0 === ou_name_list.length) {
      setSelectedOuDisplayName(
        alreadySharedCount > 0 ? `+${alreadySharedCount}` : '',
      );
    } else if (totalExtra === 0) {
      setSelectedOuDisplayName(ou_name_list[0]);
    } else {
      setSelectedOuDisplayName(`${ou_name_list[0]} +${totalExtra}`);
    }
  };

  const [visibleItems, setVisibleItems] = useState<{ [key: string]: boolean }>(
    {},
  );

  const handleToggleVisibility = (key: string) => {
    setVisibleItems((prevState) => ({ ...prevState, [key]: !prevState[key] }));
  };

  const hasDisabledDescendant = (children: OuItem[]): boolean => {
    return children.some(
      (child) =>
        disabledOuIds.includes(child.id) ||
        hasDisabledDescendant(child._childern || []),
    );
  };

  const getOuTree = (
    popupState: PopupState,
    ous: OuItem[],
    prefix: string = '',
  ): React.ReactNode[] => {
    let list: React.ReactNode[] = [];
    if (ous && Array.isArray(ous)) {
      for (let i = 0; i < ous.length; i++) {
        const item = ous[i];
        // Always treat the parent (user) OU as selected for display if edit is disabled
        let isSelected =
          selectedOu.includes(item.name) ||
          (disableUserOuEdit && item.id === parent_ou.id);
        const isOuDisabled = disabledOuIds.includes(item.id);
        const hasDisabledBelow =
          !isOuDisabled && hasDisabledDescendant(item._childern || []);
        const key = prefix + i;
        // const isVisible = visibleItems[key] || false;
        let isVisible =
          prefix === ''
            ? true
            : visibleItems[key] || isOuDisabled || hasDisabledBelow || false;
        if (ouSearchValue) {
          isVisible = true;
        }
        const _children = getOuTree(
          popupState,
          item._childern || [],
          key + '_',
        );

        list.push(
          <div key={key + 'div'} style={{ background: '#ffffff' }}>
            <Tooltip
              placement='left'
              title={<span className='span_NewSummary'>{item.name}</span>}
              arrow
            >
              <MenuItem
                key={key}
                className='OuMenuChild'
                onClick={(e) =>
                  !isOuDisabled && handleOuClick(e, item, popupState)
                }
                style={
                  isOuDisabled ? { opacity: 0.45, cursor: 'not-allowed' } : {}
                }
              >
                <span
                  className='plusMinusIc'
                  onClick={(e) => {
                    e.stopPropagation();
                    handleToggleVisibility(key);
                  }}
                >
                  {item._childern && item._childern.length > 0
                    ? isVisible
                      ? '-'
                      : '+'
                    : '-'}
                </span>
                <ListItemText
                  primary={item.name}
                  className='childHierarch textWrapInner'
                />
                {isSelected ? (
                  <CheckIcon
                    className='checkedIcon_NewSummary'
                    style={{ width: '12px', height: '12px' }}
                  />
                ) : (
                  <CheckBoxOutlineBlankIcon
                    className='unCheckedIcon_NewSummary'
                    style={{ width: '12px', height: '12px' }}
                  />
                )}
              </MenuItem>
            </Tooltip>
            {isVisible && (
              <div key={key + 'childern'} className='childern'>
                {_children}
              </div>
            )}
          </div>,
        );
      }
    }
    return list;
  };

  return (
    <div className='Form'>
      <Grid>
        {showOuList ? (
          <Grid
            className='DPvesselDropdown'
            sx={{ marginRight: '15px !important' }}
          >
            <PopupState variant='popover' popupId='ou-popup-menu'>
              {(popupState) => (
                <React.Fragment>
                  <Button
                    className={`DPVesselName ${className}`}
                    variant='contained'
                    {...bindTrigger(popupState)}
                    disabled={isReports ? true : false}
                  >
                    <span className='DPtextWrap'> {selectedOuDisplayName}</span>
                    {popupState.isOpen ? (
                      <ArrowDropDownIcon
                        key='ouArrow'
                        className='DPdropdownArrow margin-left-auto'
                        style={{
                          cursor: 'pointer',
                          transform: 'rotate(-180deg)',
                        }}
                      />
                    ) : (
                      <ArrowDropDownIcon
                        key='ouArrow'
                        className='DPdropdownArrow margin-left-auto'
                      />
                    )}
                  </Button>
                  <Menu
                    {...bindMenu(popupState)}
                    id={
                      isSmall
                        ? 'DPmenuSmall-ou'
                        : className
                          ? 'dpDropdownMenu-ou'
                          : 'DPmenu-ou'
                    }
                    aria-labelledby='menu-ou'
                    onClose={() => handleOuClose(popupState)}
                    key='menu-ou'
                    className='childHierarchy'
                  >
                    <MenuItem
                      key={'ou_text'}
                      className='vessel_search_item vessel_search_item'
                      onKeyDown={(e) => e.stopPropagation()}
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <TextField
                        id='ousearchtext'
                        variant='outlined'
                        placeholder='Type something'
                        autoComplete='off'
                        size='medium'
                        value={ouSearchValue}
                        onChange={(event) => {
                          handleOuSearch(event.target.value);
                        }}
                        InputLabelProps={{ className: 'serachLabel' }}
                        InputProps={{
                          className: 'serachBar',
                          startAdornment: (
                            <InputAdornment position='start'>
                              <SearchIcon
                                style={{
                                  position: 'absolute',
                                  right: '12px',
                                  fontSize: '12px',
                                }}
                                className='cursorPointer'
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <img
                        src={close}
                        onClick={() => handleOuClose(popupState)}
                        className='image-style'
                      />
                    </MenuItem>
                    <span>
                      {getOuTree(
                        popupState,
                        ouSearchValue ? newOrganisationsList : organisations,
                      )}
                    </span>
                  </Menu>
                </React.Fragment>
              )}
            </PopupState>
          </Grid>
        ) : (
          <></>
        )}
        {/* {
        loading ? (
          <div style={{ position: "absolute", top: "63px", right: "36px" }}>
            <Loader radius={4} length={5} lines={10} width={2} color={"#264C86"} />
          </div>
          ) : <></>
        } */}
      </Grid>
    </div>
  );
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  errorReducer: state.errorReducer,
});
export default withRouter(
  connect(mapStateToProps, {
    getDPList,
  })(Org_Drop_Down),
);
